import { useEffect, useState } from "react";

import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import { useAuth } from "@hl/shared-features/lib/features/auth/AuthContext";
import {
  BrandJustLogo,
  NotFound,
  ServerError,
} from "@hl/shared-features/lib/features/layout";
import { Stack, Text } from "@mantine/core";
import { Navigate, useSearchParams } from "react-router-dom";

import { USER_URL } from "../../config";

import {
  PublicUserProfileDocument,
  useVerifyTwitterConnectionMutation,
} from "./queries/profile.graphql.generated";

export const MyProfile = () => {
  const { loading: loadingAuth, walletAddress } = useAuth();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [verifyTwitterConnectionMutation] = useVerifyTwitterConnectionMutation({
    refetchQueries: [PublicUserProfileDocument],
  });

  useEffect(() => {
    const code = searchParams.get("code");
    const sessionState = searchParams.get("state");

    if (sessionState && code && walletAddress) {
      verifyTwitterConnectionMutation({
        variables: {
          code,
          state: sessionState,
        },
      }).then((data) => {
        setLoading(false);
        if (data?.errors?.length) {
          setError(true);
        }
      });
    } else {
      setLoading(false);
    }
  }, [walletAddress]);

  if (loading || loadingAuth) return <LoadingPage />;
  if (!walletAddress) return <NotFound />;

  if (error) return <ServerError />;

  // If we connect an account in another tab we cant just redirect to the account settings page
  // This is used when connecting accounts happens in a modal or not on the account settings page
  // e.g. Artemis - Onboarding modal
  if (searchParams.get("close") === "true") {
    return (
      <Stack h={"100vh"} justify="center" align="center">
        <BrandJustLogo width={"100%"} height={48} />
        <Text size={32} fw={500} mt={16}>
          Successfully linked your account
        </Text>
        <Text size={18} c={"dimmed"}>
          This tab will close automatically
        </Text>
      </Stack>
    );
  }

  return (
    <Navigate
      to={USER_URL.user.accountSettings.default.replace(":slug", walletAddress)}
    />
  );
};
